import { Facility } from "@/types/warehouse"
import { RadioGroupItem } from "@/components/ui/radio-group"
import { Label } from "@/components/ui/label"
import { cn, parseJsonProperty } from "@/lib/utils"
import { MetroIcon } from "@/components/icons"

export function FacilityItem({ facility }: { facility: Facility }) {
  const subway = parseJsonProperty<{ name: string; color?: string } | null>(
    facility.properties?.find((property) => property.code === "subway")?.value,
    null,
  )
  const displayName = facility.properties?.find(property => property.code === 'display_name')?.value

  return (
    <div>
      <RadioGroupItem id={facility.code} value={facility.code} className="peer sr-only absolute" />
      <Label
        htmlFor={facility.code}
        className={cn(
          "flex flex-col items-start justify-between gap-2 min-h-[92px] bg-background rounded-[4px] p-3 border-2 border-transparent cursor-pointer", 
          "peer-data-[state=checked]:border-brand peer-data-[state=checked]:bg-card peer-data-[state=checked]:pointer-events-none",
          "hover:bg-card hover:border-brand"
        )}
      >
        <span className="lg:text-[18px] text-[24px] lg:leading-[24px] leading-[110%] font-bold">{displayName ?? facility.name}</span>
        {subway && (
          <span className="flex items-center gap-[6px]">
            <MetroIcon
              size={16}
              style={subway.color ? { color: subway.color } : undefined}
            />
            <span className="lg:text-[14px] text-[12px] lg:leading-[18px] leading-[16px] font-medium text-light-muted">{subway.name}</span>
          </span>
        )}
      </Label>
    </div>
  )
} 